/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Phone/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Description from './Description/index'
import Icons from './Icons/index'
import Number from './Number/index'
import React from 'react'
import Type from './Type/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Phone({
  children,
  viewPath = "/DesignSystem/DataVaxiomProfessionalView/Content/Phone/Phones/Content/Phone"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Phone.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-5yCzy': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<Number
  viewPath={`${viewPath}/Number`}
/>
<Type
  viewPath={`${viewPath}/Type`}
/>
<Icons
  viewPath={`${viewPath}/Icons`}
/>
<div
  data-testid="Phone.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Description
  viewPath={`${viewPath}/Description`}
/>
</div>
</div>
{children}
</React.Fragment>)
}